export default __webpack_public_path__ + "static/media/profile.902bb2f3.svg";